export const formatDateTime = (date: Date | string): string => {
    if (!date)
        return 'NONE';

    const dateTyped = typeof date === 'string' ? new Date(date) : date;

    const formattedDate = dateTyped.toLocaleDateString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: '2-digit'
    });

    const formattedTime = dateTyped.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });

	return `${formattedDate} - ${formattedTime}`;
};

export const convertUtcToCst = (
	utcDate: string,
	format: string = 'MM/DD/YYYY', // Default format is 'MM/DD/YY'
	includeTime: boolean = false, // Option to include time, default is false
	toCst: boolean = false // Option to convert to CST, default is false
): string => {
	// hh:mm A 12hrs format
	// HH:mm 24hrs format
	if (!utcDate) return 'NONE'; // Handle missing utcDate

	try {
		// Convert the UTC date string to a Date object
		const date = new Date(utcDate);
		if (isNaN(date.getTime())) return 'Invalid date'; // Handle invalid date

		// Convert to CST if required using the 'America/Chicago' timezone
		let targetDate = date;
		if (toCst) {
			const chicagoTime = new Date(date.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
			targetDate = chicagoTime;
		}

		// Helper function to pad numbers (e.g., 1 => 01)
		const pad = (num: number) => String(num).padStart(2, '0');

		// Extract date components
		const year = targetDate.getFullYear();
		const month = pad(targetDate.getMonth() + 1); // Month is 0-based
		const day = pad(targetDate.getDate());

		// Build the formatted date string
		let formattedDate = format
			.replace('YYYY', String(year))
			.replace('YY', String(year).slice(-2))
			.replace('MM', month)
			.replace('M', String(targetDate.getMonth() + 1))
			.replace('DD', day)
			.replace('D', String(targetDate.getDate()));

		// Handle time formatting if requested
		if (includeTime) {
			const hours = targetDate.getHours();
			const minutes = pad(targetDate.getMinutes());
			const hours12 = hours % 12 || 12; // 12-hour format
			const ampm = hours >= 12 ? 'PM' : 'AM';

			// Append time to the formatted date
			if (format.includes('HH')) {
				// 24-hour format
				formattedDate += ` ${pad(hours)}:${minutes}`;
			} else if (format.includes('hh')) {
				// 12-hour format with AM/PM
				formattedDate += ` ${hours12}:${minutes} ${ampm}`;
			}
		}
		formattedDate = formattedDate.replace('HH:mm', '').replace('hh:mm A', '');
		return formattedDate;
	} catch (error) {
		console.error('Date formatting error:', error);
		return 'Invalid date';
	}
};
